export const BULLET_POINT = "\u2022";
